<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6></v-flex>
      </v-layout>
      <h1>Messaging requests ({{ p_name }})</h1>
      <h2>Open requests</h2>
      <p>In the following table, you see all the pending requests.</p>
      <Loading v-if="!l_open_requests"/>
      <v-data-table v-if="l_open_requests" :headers="headers" :items="open_requests_items">
        <template v-slot:item.data="{ item }">
          <tree-view style="max-width:50%;" v-if="checkJSON(item.data)" :data="JSON.parse(item.data)" :options="treeview_options"></tree-view>
          <div style="max-width:50%;" v-else>{{ item.data }}</div>
        </template>
      </v-data-table>
      <h2>Sent requests</h2>
      <p>In the following table, you see the last 25 sent requests.</p>
      <Loading v-if="!l_sent_requests"/>
      <v-data-table v-if="l_sent_requests" :headers="headers" :items="sent_requests_items">
        <template v-slot:item.data="{ item }">
          <tree-view style="max-width:50%;" v-if="checkJSON(item.data)" :data="JSON.parse(item.data)" :options="treeview_options"></tree-view>
          <div style="max-width:50%;" v-else>{{ item.data }}</div>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { MessagingSettings } from "../logic/MessagingSettings";
import { Projects } from "../logic/Projects";

export default {
  name: "MessagingRequests",
  data() {
    return {
      p_name: "...",
      project_id: 0,
      headers: [
        {
          text: "ID",
          value: "id"
        },
        {
          text: "Data",
          value: "data"
        },
        {
          text: "Planned",
          value: "planned"
        }
      ],
      open_requests_items: [],
      sent_requests_items: [],
    
      //Loaders
      l_open_requests: false,
      l_sent_requests: false,

      treeview_options: {
        maxDepth: 1,
        rootObjectKey: "",
        link: true
      }
    }
  },
  mounted() {
    this.project_id = this.$route.params.project_id;

    this.loadProjectMeta(this.project_id);
    this.getOpenRequests();
    this.getSentRequests();

    this.setTitle("Messaging Requests");
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    async getOpenRequests() {
      var response = await MessagingSettings.getOpenRequests(this.project_id);
      if (response.body !== undefined) {
        this.open_requests_items = response.body;
      }
      this.l_open_requests = true;
    },
    async getSentRequests() {
      var response = await MessagingSettings.getSentRequests(this.project_id);
      if (response.body !== undefined) {
        this.sent_requests_items = response.body;
      }
      this.l_sent_requests = true;
    },
    checkJSON(data) {
      // eslint-disable-next-line
      if (/^[\],:{}\s]*$/.test(data.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        return true;
      }else{
        return false;
      }
    },
    back() {
      this.$router.replace("/project/" + this.project_id);
    }
  }
};
</script>

<style>
</style>